import Anthropic from "@anthropic-ai/sdk";

const anthropic = new Anthropic({
  apiKey: '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',
  dangerouslyAllowBrowser: true
});

export const streamAnthropicMessages = async ({ messages, model, maxTokens, onText, onEnd, onError }) => {
  try {
    const textStream = await anthropic.messages.stream({
      messages,
      model,
      max_tokens: maxTokens,
    });

    textStream.on("text", onText);
    textStream.on("end", onEnd);
    textStream.on("error", onError);

    return textStream;
  } catch (error) {
    throw new Error(`Anthropic API Error: ${error.message}`);
  }
};

export default anthropic;